import type { ReactNode } from "react";

import { BlurView } from "expo-blur";
import { type StyleProp, StyleSheet, View, type ViewStyle } from "react-native";

import { colors } from "@/constants/colors";

export function GBlurView({
  children,
  style,
}: {
  children?: ReactNode;
  style?: StyleProp<ViewStyle>;
}) {
  return (
    <View style={[styles.base, style]}>
      <BlurView intensity={40} style={StyleSheet.absoluteFill} tint="dark" />
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  base: {
    backgroundColor: colors.darkOverlay,
    overflow: "hidden",
  },
});
